import React from 'react';
import { SnapshotActivity } from './SnapshotActivity';
import { SnapshotAccessEvents } from './SnapshotAccessEvents';
import { snapshotPanelStyles } from './styles';

export function SnapshotPanel(): React.ReactElement {
  return (
    <div className={snapshotPanelStyles.root}>
      <SnapshotActivity />
      <SnapshotAccessEvents />
    </div>
  );
}
